/* eslint-disable */
import React from 'react';
import axios from 'axios';
import {  Link, hashHistory  } from 'react-router'
import DocumentMeta from 'react-document-meta';
import cookie from 'react-cookie';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import theme from '../public/react-toolbox/theme.js'
import '../public/react-toolbox/theme.css'
import './App.css';
import getResult from './Api';
import Autocomplete from "./Autocomplete";

const Loading = require('./loading');
const Overlay = require('./Overlay');
const config = require('./config');
const alerts = require('./AlertsMsg');
const lang = require('./lang');
const APIURL = config.path.apiUrl;
const APIURLPRO = config.path.apiUrlPro;
const APPID = config.ids.appId;
const APIURLv2 = config.path.apiUrlv2;
var helper = require("./Helper.js");
const Alert = require('./alert');

var Select = require('react-select');
 import 'react-select/dist/react-select.css';
 //import 'rc-time-picker/assets/index.css';
 const apps = require('./apps');
 var strp = require('strp');
 var dateFormat = require('dateformat');
 const datetime = new Date();
 var currentDateValue = datetime.getDate();

 var defaultDate = '';
 var defaultresTime = '';
 var min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
 var max_datetime =  new Date(new Date(datetime).setDate(currentDateValue + 15));
 
 var monthNamesArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
 
 let timetxt = new Date();
     timetxt.setHours(17);
     timetxt.setMinutes(28);


	/* Load meta tags */
	const meta = {
      title: lang.delivery_address_meta_title,
      description: lang.delivery_address_meta_des,
      meta: {
        name: {
          keywords: lang.delivery_address_meta_title
        }
      }
    };
    
     const expires = new Date();
	expires.setDate(expires.getDate() + 1);

class Addresslist extends React.Component {
	
	constructor(props) {
	   super(props);
	   /* Declare state */
	   this.state = {zoneOutletSeleted: "", zoneDeliveryOutlet: '', deliveryOutlets:[],zoneDetails : [], windowHeightNormal:0,windowHeight:0,searchHtml:'',secAddrData:[],addressField:'',Outlets:[],category: [],common: [],banner:[], bannercom:[],defaultAvilablity:config.ids.defaultAvilablityName,defaultAvilablityImage:"",navStatus:"Loading",openNav:'side-l',rewadNav:'collapsed','login':'',searchText:'',settings:[], options : [],showPromoPopup:"No", showNormalPopup: 'No',pageDesc:''  ,bannersource:'',noPagerClass:"",bxClass:'',onetimeclickstate:"No",orderDeliveryAddress:"" };
	   
	   var promise = getResult('settingsPro','No');
			 promise.then(res => {
			  this.setState({settings: res.data.result_set });
			 
			 /* load menu items */
			 this.loadMenuNavigation("634E6FA8-8DAF-4046-A494-FFC1FCF8BD11","Delivery","/img/icons/Delivery_white.png",'');

		  });
	   
	 }
	 
	 componentDidMount() {
		 cookie.remove('Autolatitude');
		 cookie.remove('Autolongitude');
		 cookie.remove('AutolocationAddress');
	 }
	 
	 autoCompleteSubmit(){
		 
		 var latitude = cookie.load('Autolatitude'); 
		 var longitude = cookie.load('Autolongitude'); 
		 var locationAddress = cookie.load('AutolocationAddress');
		 
		 if((typeof latitude !== "undefined") && (typeof longitude !== "undefined")){
			 
			 axios.get(APIURL+'outlets/find_outlet_byaddress?skip_timing=Yes&app_id='+APPID+"&availability_id="+config.ids.deliveryId+"&latitude="+latitude+"&longitude="+longitude+"&")
			.then(res => {
				if(res.data.status === "ok") {
					var orderDeliveryAddress = locationAddress;
					var orderHandled = res.data.result_set.outlet_name+", Crew will be seeing you in "+res.data.result_set.outlet_delivery_timing+" Minutes";
					
					this.setState({orderDeliveryAddress:orderDeliveryAddress});
					this.setState({orderHandled:orderHandled});
					
					cookie.save('orderOutletId',res.data.result_set.outlet_id);
					cookie.save('orderOutletName',res.data.result_set.outlet_name);
					cookie.save('orderPostalCode','');
					cookie.save('orderTAT',res.data.result_set.outlet_delivery_timing);
					cookie.save('orderDeliveryAddress',orderDeliveryAddress);
					cookie.save('orderHandled',orderHandled);
					
					cookie.save('outlet_tax_option',res.data.result_set.outlet_tax_option);
					cookie.save('outlet_tax_surcharge',res.data.result_set.outlet_tax_surcharge);
					cookie.save('outlet_tax_surcharge_inclusive',res.data.result_set.outlet_tax_surcharge_inclusive);
					
					var orderHandledText = res.data.result_set.outlet_name +" "+res.data.result_set.outlet_address_line1+" "+res.data.result_set.outlet_address_line2+", Philippines ";
					
					$('#deliveryAddline').css("display","none");
					$('#DeliverySucess').css("display","block");
					
				}else{
					
					$('#deliveryAddline').css("display","none");
					$('#DeliveryError').css("display","block");
					
				}
			});
			 
		 }else{
			 $('.addressline-error').html("Sorry !, We couldn't find your address. Pls check and try again.");
			 setTimeout(function(){
				$('.addressline-error').html('');
			},2000);
		 }
	 }
	 
	 redirecthome(){
		 hashHistory.push("/");
	 }
	 
	 changeAddresline() {
		$('#deliveryAddline').css("display","block");
		$('#DeliveryError').css("display","none");
		
		this.setState({orderDeliveryAddress:''});
		this.setState({orderHandled:''});
		
		cookie.remove('orderOutletId');
		cookie.remove('orderOutletName');
		cookie.remove('orderPostalCode');
		cookie.remove('orderTAT');
		cookie.remove('orderDeliveryAddress');
		cookie.remove('orderHandled');
		
	 }
	 
	 /* BX slider */
   	__bxslider(){
		 console.log('bx loaded');
		var bxslider = $('.bxslider').bxSlider({
						infiniteLoop: true,
						auto: true,
						pause: 4000
						}); 
	}
	
	componentWillMount() {
		
		 var windowHeight =  window.innerHeight;
		 this.setState({'windowHeight':(windowHeight - 45)+'px'}); 
		 this.setState({'windowHeightNormal':(windowHeight)+'px'});
 
		 /* load banner */
				 axios.get(APIURL + 'cms/banner?app_id=' + APPID)
			.then(res => {
			 
			if (res.data.status === "ok") {
				var sliderLen = res.data.result_set;
				var noPageClass = (sliderLen.length === 1 ? "bx-slide-single" : "" );
				var bxClass = (sliderLen.length === 1 ? "" : "bxslider" );
				//this.setState({ banner: res.data.result_set });	
				this.setState({bxClass: bxClass, banner: res.data.result_set , bannersource: res.data.common.image_source,noPagerClass :noPageClass  });	
				
			}  
		});
			
	 }
	 
	 /* format date'es */ 
    parseDate(input) {
	  var parts = input.match(/(\d+)/g);
	  // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
	  return new Date(parts[0], parts[1]-1, parts[2]); // months are 0-based
	}
	
	/* Menu open and close */
	openNavmenu() {
	//console.log('open');
	    cookie.save('navmenuClk', 'open');
		document.getElementById("mySidenav").className = "sidenav nav-width";
		document.getElementById("parentDisable").style.display = "block";
		this.setState({openNav:'side-l side-l-tran'}); //rewadNav
		this.setState({rewadNav:'side-l side-l-tran'});
	 //	$("#promo_popup").modal("toggle"); 
	}

	closeNav() {
		//console.log('close');
		cookie.save('navmenuClk', 'close');
		document.getElementById("mySidenav").className = "sidenav";
		document.getElementById("parentDisable").style.display = "none";
		this.setState({openNav:'side-l side-l-out'});
		this.setState({rewadNav:'side-l side-l-out'});
	}
	
	 /* this function used to load menu navigation */
 loadMenuNavigation(currentAvi,availText,availImage,loading)
 {
        
		if(loading === "Yes" ){
		   this.setState({navStatus: "Loading"});
		}
		
		var orderOutletIdTxt = cookie.load('orderOutletId');
        var addqueryTxt = '';
        
		if(typeof orderOutletIdTxt !== "undefined" && orderOutletIdTxt !== '') {
			addqueryTxt = "&outletIdTxt="+orderOutletIdTxt;
		}
		
		axios.get(APIURL+'productsver3/navigation_menu?app_id='+APPID+addqueryTxt+"&availability="+currentAvi)
		.then(res => {
			if(res.data.status === "ok"){
			  this.setState({navStatus: res.data.status});
			  this.setState({common: res.data.common});
			  this.setState({category: res.data.result_set});
			  this.setState({defaultAvilablityImage: availImage});
			  this.setState({defaultAvilablity: availText});

			 // this.setstate({defaultAvilablityImage:availImage });
		  }else {
			this.setState({navStatus: res.data.status});
		  }
	   });
	
 }
 
 __showBanners(){

  this.__bxslider()
  
	if(this.state.banner){
			return this.state.banner.map((loaddata, index)=>
			 <div key={index}  >
				<img  src={this.state.bannersource + loaddata.banner_image}   alt="Loading..." />
					{/* <p className="legend">{loaddata.banner_name}</p> */}
			 </div>
			);
		}else{ 		 return ( <div> <img    src="img/header-img.jpg"   alt="Loading..." /> </div>);
		}
	}
	
	/* return navigation menu slug */
	__navLink(menu_type,CateId,subCateId,slideno) {
	 return  (menu_type ==="sub")? "/products/subcategory/"+subCateId+"/"+slideno : "/products/category/"+CateId+"/"+slideno;
	}

	/* return navigation image value.  like no image, category image, sub category image */
	__navImage(menuType,cateImgae,subCateImage,cateUrl,subcateUrl) {
	  var image = (menuType === "sub")? subCateImage : cateImgae;
	   var imageUrl = (menuType === "sub")? subcateUrl : cateUrl;
	   return  (image === null || image === "" )? "/img/no-images/products-no-image.jpg" : config.path.tinThumpUrl+imageUrl+"/"+image+"&w=768&h=265&q=80";
	}
	
	/* this function used to show office timing*/
	  showTimer()
	  {
		   return helper.shopTiming(this.state.settings.ninja_pro_operation_time_start, this.state.settings.ninja_pro_operation_time_end);
	  }
	  /* open  direction link */
	  targetMap()
	  {
		if( typeof this.state.settings.ninja_pro_direction_url != "undefined" || this.state.settings.ninja_pro_direction_url !== "") {
		window.open(this.state.settings.ninja_pro_direction_url);
		} 
	  }
	  
	  /* load home banner image */
	 homeBanner()
	 { //img/logo.png
		 return  (typeof this.state.settings.ninja_pro_home_banner === "undefined" || this.state.settings.ninja_pro_home_banner === "" )? "/img/no-images/products-no-image.jpg" : config.path.tinThumpUrl+this.state.settings.ninja_pro_home_banner+"&w=768&h=265&q=80";
	 }
	  /* load home logo  image */
	 loadLogo()
	 { //img/logo.png
		 return  (typeof this.state.settings.ninja_pro_logo === "undefined" || this.state.settings.ninja_pro_logo === "" )? "/img/logo.png" : config.path.tinThumpUrl+this.state.settings.ninja_pro_logo+"&w=191&h=51&q=80";
	 }

	/* this function used to load mobile number */ 
	loadNumber()
	{
	  if( typeof this.state.settings.ninja_pro_phone_number != "undefined" || this.state.settings.ninja_pro_phone_number !== "") {
		  return "tel:"+this.state.settings.ninja_pro_phone_number;
		} 
	 
	}
	
	/* food types */
	foodTypes()
	{

		if(this.state.settings.ninja_pro_food_types && this.state.settings.ninja_pro_food_types.length > 0){
				return this.state.settings.ninja_pro_food_types.map((loaddata, index)=>
				<button key={index} type="button" className="btn pull-right food-type-btn" style={{cursor:'text'}}>{loaddata}</button>              
				);
			}
	}

	 
	 /* bx slider  - no pager class */
	 bxNoPager()
	 {
		var sliderLen = this.state.banner;
		 console.log(sliderLen.lenght);
		  if(this.state.banner.lenght === 1) {
			   return "bx-slide-single";
		}
		 
	 }
	 
	 __ProductListing(){
 
   if(this.state.navStatus === "Loading2"){  
        return (
            <div className="home-load-div" > <img src="/img/loader.gif" alt="" className="home-load-img"  /> </div>
        );
   }
   else if(this.state.navStatus === "ok" ){
		return   this.state.category.map((loaddata, index)=>
			<div className="col-xs-12 nopadding home-bottom-img" key={index} >
			  <div className="gradient-img">  
			       <Link key={index} to={this.__navLink(loaddata.menu_type,loaddata.menu_category_id,loaddata.pro_subcate_id,index)} >
						<img src={this.__navImage(loaddata.menu_type,loaddata.pro_cate_image,loaddata.pro_subcate_image,this.state.common.category_image_url,this.state.common.subcategory_image_url)} alt="" className="img-responsive" />
						<p className="text-left font-bold text-uppercase pd-l-20">{strp.stripslashes(loaddata.menu_custom_title)}</p>
					</Link>
				</div>
			</div>
					
		);

	}else {
		return(<div className="col-xs-12 nopadding home-bottom-img no_pro_home"  >  <span> {lang.no_products_found}  </span> </div> );

	}
}
	
	render() {

	  if(this.state.navStatus === "Loading"){

	 return ( <div className="container-fluid desktop-container position-rel" style={{minHeight:this.state.windowHeightNormal}}>
            <div className="row">
               <Loading/>
            </div>
        </div>
	  
        
	 );
	}else { 
	return (

	<div> <DocumentMeta  {...meta} />
			 
		<div className="container-fluid desktop-container position-rel" style={{minHeight:this.state.windowHeightNormal}}>
			<div id="parentDisable"></div>
			<div className="row">
				<div className="col-xs-12 head-dropdwn nopadding" >
					<div className="dropdown center-block">
						<button type="button" className="btn home-modal-button" data-toggle="modal" data-target="#onload-screen" data-keyboard="false" data-backdrop="static">
							<p className="text-center dine-in-text">
								<img alt=""  src={this.state.defaultAvilablityImage} className="icon-img-small"/>
								{ " " }<span  style={{fontSize: '16px'}}>{this.state.defaultAvilablity}</span>{ " " }
								<img alt=""  src="/img/icons/arrow-down.png" className="icon-img-small"/>
							</p>
						</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12 top-nav padding-0 head-main">
					<div className="col-xs-4 head-child">
						<span  className="cursor-pointer side-l1" onClick={this.openNavmenu.bind(this)} >
							<img alt=""  src="/img/menu.png" className="icon-img-small5 menuicon"/></span>
					</div>

					<div className="col-xs-4 head-child">
						<img alt=""  src={this.loadLogo()} className="logo-main center-block"/>
					</div>

				</div>
			</div>

			<div id="mySidenav" className="sidenav">
			 <br /> <br />
				<div className="side-nav-header">
				 <div className={this.state.openNav}>
					<img className="logo " alt="" src={this.loadLogo()} />
					   </div>
					<a  style={{cursor:'pointer'}} className="closebtn" onClick={this.closeNav.bind(this)}  >
						<img alt="" src="/img/icons/menu2.png" id="close-btn-nav"/>
					</a>
				</div>
			   <Link to="/"  onClick={this.closeNav.bind(this)} className={this.state.openNav}><img alt="" src="/img/icons/home.png"/>{" "}{lang.navigation.home}</Link>
			   <Link to={(typeof cookie.load('UserId') === 'undefined' || cookie.load('UserId') === null )? "sign-in" : "my-account"} className={this.state.openNav}><img alt="" src="/img/icons/user.png"/> {" "}{lang.navigation.myaccount}</Link>
				<Link to="/orders" className={this.state.openNav}><img alt="" src="/img/icons/orders.png"/> {" "}{lang.navigation.vieworders}</Link>
			  

				<div className="grey-seperater"></div>

				  <Link to="pages/about-us" className={this.state.openNav}><img alt="" src="/img/icons/info.png"/> &nbsp;{lang.navigation.about}</Link>
				  
				   <Link to="pages/terms-conditions" className={this.state.openNav}><img alt="" src="/img/icons/info.png"/> &nbsp;Terms & Conditions</Link>
				 
				<Link to="pages/privacy-policy" className={this.state.openNav}><img alt="" src="/img/icons/lock.png"/> &nbsp;{lang.navigation.privacy}</Link>
				<Link to="module/contact-us" className={this.state.openNav}><img alt="" src="/img/icons/phone.png"/> &nbsp;{lang.navigation.contact}</Link>
			</div>

			<div className="row">
			
            <div  className={this.state.noPagerClass}>
				<ul className={this.state.bxClass}>
				{this.__showBanners()}
				</ul>
            </div>
				<div className="col-lg-12 nopadding">
					<div className="bottom-nav">
						<div className="col-xs-6 nopadding call_com  opr_time">
							<p className="b-txt pd-l-20">
							  <Link onClick={this.targetMap.bind(this)} style={{cursor:'pointer',color:'#fff'}}>  <img alt=""  src="/img/icons/compass.png" className="icon-img-small-2"/> {" "}Direction{" "}</Link>
							  <a href={this.loadNumber()} style={{cursor:'pointer',color:'#fff'}}><span className="bottom-nav-cal"><img alt=""  src="/img/icons/phone-reciver.png" className="icon-img-small-2"/>Call</span></a></p>
						</div>

						<div className="col-xs-6 nopadding call_com">
						 <p className='b-txt text-right pd-r-20'> {this.showTimer()} </p>

						</div>

						<div className="clearfix"></div>
					</div>
				</div>
				<div className="col-xs-12 heading-div our_special_head">
					<div className="col-xs-4 pd-l-20 our_menu_com our_special_titile"><h1 className="heading pull-left"   > Our Menu</h1></div>
					<div className="col-xs-8 pd-r-20 our_menu_com">
						{this.foodTypes(this)}
					</div>
				</div>
				{ this.__ProductListing() }
				
				
			</div>
			
			
			<div className="delivery_addpopup_wrapper" id="deliveryAddline">
				<div className="white-outer center-block deliveryAddPopup" id="forgotpassword-form">
					<div className="col-xs-10 div-center">
						<div className="space-20"></div>
						<a href="#" className="back-to-home"><img src="/img/icons/modal-close.png" className="img-responsive" alt=""  /></a>
						<p className="text-center font-bold font-size-18">YOUR DELIVERY ADDRESS</p>
						 <div id="form-msg"></div>
						<div className="space-5">
						
						</div>
						<div className="form-group label-floating is-empty card-nos">
						<span className="addressline-error"></span>
							<div className="input-group">
								<Autocomplete />
							</div>
						</div>
						<div className="space-20"></div>
						<div className="text-center ">
							<button type="button" className="btn btn-raised btn-info full-width-btn text-uppercase" onClick={this.autoCompleteSubmit.bind(this)}>Continue<div className="ripple-container"></div></button><br/>
						</div>
						<div className="space-20"></div>
					</div>
					<div className="clearfix"></div>
				</div>
			</div>
				
				<div className="modal" id="DeliverySucess">
						<div className="modal-dialog PopupWidth">
							<div className="modal-content">
								<div className="modal-header">
									<h4 className="modal-title">
										<img src="/img/icons/DeliverySucess.png" className="img-responsive" alt="thumb-up" />
										Awesome, we can deliver!</h4>
								</div>
								<div className="modal-body text-center">
									<p><b>Your Delivery Address: </b><br />
										{this.state.orderDeliveryAddress}</p>
									<br />
									<button type="button" onClick={this.redirecthome.bind(this)} className="btn btn-raised btn-info ">Continue</button>
									<br />
									<br />
								</div>
								<div className="modal-footer">
								</div>
							</div>
						</div>
					</div>
					
				<div className="modal" id="DeliveryError">
						<div className="modal-dialog PopupWidth">
							<div className="modal-content">
								<div className="modal-header">
									<a href="#" className="back-to-home closeIconimg"><img src="/img/icons/modal-close.png" className="img-responsive" alt=""  /></a>
									<h4 className="modal-title">
										<img src="/img/icons/Cant_Deliver.png" className="img-responsive" alt="" />
										Sorry !</h4>
								</div>
								<div className="modal-body" >
									<p>Sorry we cant deliver to your address <br />
										Do you want to change your address or check again later ?</p>
									<br />
									<div className="col-sm-3">&nbsp;</div>
									<div className="col-sm-6">
									<button type="button" onClick={this.changeAddresline.bind(this)}  className="col-lg-6 btn btn-raised btn-info fullwidth ">Change Address</button>
									</div>
									<div className="col-sm-3">&nbsp;</div>
									<br />
									<br />
									<br />
								</div>
								<div className="modal-footer"></div>
							</div>
						</div>
					</div>
					
					<div className="modal" id="ShopClosedError">
							<div className="modal-dialog PopupWidth">
								<div className="modal-content">
									<div className="modal-header">
										<a href="#" className="back-to-home closeIconimg"><img src="/img/icons/modal-close.png" className="img-responsive" alt=""  /></a>
										<h4 className="modal-title">
											<img src="/img/icons/Cant_Deliver.png" className="img-responsive" alt="" />
											Sorry !</h4>
									</div>
									<div className="modal-body" >
										<p><b>Outlet Closed Temporarily. Please Try again later</b>	</p>
										<br />
										<div className="col-sm-12">
										<button type="button" onClick={this.redirecthome.bind(this)} className="col-lg-6 btn btn-raised btn-info fullwidth ">Check Later</button>
										</div>
										 
										<br />
										<br />
										<br />
									</div>
									<div className="modal-footer">


									</div>
								</div>
							</div>
						</div>	
			
			</div>
						
		 </div>
	);}
  }
}

export default Addresslist;



// WEBPACK FOOTER //
// ./src/Addresslist.js